/* eslint-disable camelcase, @typescript-eslint/naming-convention */
// Types for TenantKnowledgeBase settings feature.
// Snake_case fields mirror the admin JSON API payloads verbatim (no client-side
// remapping). directive_machine is intentionally absent — it is NEVER exposed.
// ── Manual-entry safety gate (nl-extraction-output-v1 §Manual-entry safety gate) ──
// create/update screen the directive through the ip-assistant validate endpoint
// BEFORE persisting. accept → the rule is saved (kind: 'saved'); reword → no
// persist, a salvaged proposal the admin can one-click accept (kind: 'reword');
// reject → the request throws (422) with the reason in response.data.error.
export const REWORD_VERDICT = 'reword';
